<div class="product-filters">


  <!-- ====================================================
       MOBILE HEADER
       ==================================================== -->

  <div class="mobile-filter-header">

    <div class="mobile-filter-title">

      <mat-icon>
        filter_alt
      </mat-icon>

      <h2>
        {{ 'COMMON.FILTER' | translate }}
      </h2>

    </div>

  </div>


  <!-- ====================================================
       CATEGORY
       ==================================================== -->

  <div class="filter-section">

    <label>
      {{ 'FILTER.CATEGORY' | translate }}
    </label>

    <mat-form-field
      appearance="outline"
      class="filter-select"
    >

      <mat-select
        [(ngModel)]="tempCategoryId"
        (ngModelChange)="onCategoryChange()"
        panelClass="product-filter-select-panel"
      >

        <!-- 0 = ALL CATEGORIES -->

        <mat-option [value]="0">
          {{ 'FILTER.All_Categories' | translate }}
        </mat-option>

        <mat-option
          *ngFor="let category of categories"
          [value]="category.id"
        >
          {{ getCategoryName(category) }}
        </mat-option>

      </mat-select>

    </mat-form-field>

  </div>


  <!-- ====================================================
       SUBCATEGORY
       ==================================================== -->

  <div
    class="filter-section"
    *ngIf="availableSubCategories.length > 0"
  >

    <label>
      {{ 'FILTER.SUBCATEGORY' | translate }}
    </label>

    <mat-form-field
      appearance="outline"
      class="filter-select"
    >

      <mat-select
        [(ngModel)]="tempSubCategoryId"
        panelClass="product-filter-select-panel"
      >

        <!-- 0 = ALL SUBCATEGORIES -->

        <mat-option [value]="0">
          {{ 'FILTER.ALL_SUBCATEGORIES' | translate }}
        </mat-option>

        <mat-option
          *ngFor="
            let subCategory of
            availableSubCategories
          "
          [value]="subCategory.id"
        >
          {{ getSubCategoryName(subCategory) }}
        </mat-option>

      </mat-select>

    </mat-form-field>

  </div>


  <!-- ====================================================
       BRAND
       ==================================================== -->

  <div class="filter-section">

    <label>
      {{ 'FILTER.BRAND' | translate }}
    </label>

    <mat-form-field
      appearance="outline"
      class="filter-select"
    >

      <mat-select
        [(ngModel)]="tempBrandId"
        panelClass="product-filter-select-panel"
      >

        <!-- 0 = ALL BRANDS -->

        <mat-option [value]="0">
          {{ 'FILTER.ALL_BRANDS' | translate }}
        </mat-option>

        <mat-option
          *ngFor="let brand of brands"
          [value]="brand.id"
        >
          {{ getBrandName(brand) }}
        </mat-option>

      </mat-select>

    </mat-form-field>

  </div>


  <!-- ====================================================
       OFFERS
       ==================================================== -->

  <label class="offer-filter">

    <input
      type="checkbox"
      [(ngModel)]="tempOffers"
    />

    <span>
      {{ 'FILTER.OFFERS' | translate }}
    </span>

  </label>


  <!-- ====================================================
       ACTIONS
       ==================================================== -->

  <div class="filter-actions">

    <button
      type="button"
      class="clear-button"
      (click)="clearFilters()"
    >

      <mat-icon>
        close
      </mat-icon>

      {{ 'COMMON.CLEAR' | translate }}

    </button>


    <button
      type="button"
      class="apply-button"
      (click)="applyFilters()"
    >

      <mat-icon>
        filter_alt
      </mat-icon>

      {{ 'COMMON.APPLY' | translate }}

    </button>

  </div>

</div>